/**
 * Implements `StorageUtils` using `sessionStorage`.
 *
 * This class will eventually not be exported and should not be used
 * by consumers of the library.
 * @internal
 */
export class SessionStorage {
    constructor() {
        this.get = (key) => {
            return sessionStorage.getItem(key) || null;
        };
        this.set = (key, value) => {
            sessionStorage.setItem(key, value);
        };
        this.removeItem = (key) => {
            sessionStorage.removeItem(key);
        };
        this.clear = (prefix) => {
            for (let i = 0; i < sessionStorage.length; i++) {
                const key = sessionStorage.key(i);
                if (key && key.startsWith(prefix)) {
                    sessionStorage.removeItem(key);
                    i--;
                }
            }
        };
    }
}
